/**
 * Canonical UUID shape check — 8-4-4-4-12 hex, case-insensitive.
 *
 * This is intentionally **version-agnostic**: it accepts any UUID version and
 * variant (v4, v7, etc.). Almanac event ids are UUID **v7** (the version nibble
 * is `7`, e.g. `019fb019-27a5-75b9-9c9f-b1015e6c7341`), so route guards for
 * informational-event ids must NOT assume v4 — a v4-only regex renders a false
 * 404 for every real event before any fetch happens.
 */
const CANONICAL_UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isCanonicalUuid(value: string): boolean {
  return CANONICAL_UUID_RE.test(value);
}
